import { ITool } from 'app/components/Toolbox/ToolboxConstants';
import type { App } from 'app/store';

export default async function fetchConversion(app: App, tool: ITool, payload: unknown) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return app.clients.toolbox[tool.endpoint](payload as any);
}
